// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class dogPurchaseAPI extends MainAPI {
    /**
     * @return {object} list of Dog Purchase Orders
     * @params queryParams
     * */
    async getDogPurchaseList(queryParams) {
        return API.get(`${ENDPOINTS.GET_DOG_PURCHASE}/list?${queryString.stringify(queryParams)}`);
    }

    /**
     * @return No Content
     * @param {Number} dogPurchaseId
     * @param {Object} body { status }
     * */
    async updateDogPurchaseStatus(dogPurchaseId, body) {
        return API.put(`${ENDPOINTS.PUT_DOG_PURCHASE}/${dogPurchaseId}/update-dog-purchase-status`, body);
    }

    /**
    * @return Get the number of Pending Request
    * */

    async getDogPurchasePendingRequestCount() {
        return API.get(`${ENDPOINTS.GET_DOG_PURCHASE}/count`);
    }

}

export default new dogPurchaseAPI();
